import React from 'react'
import styled, { DefaultTheme, useTheme } from 'styled-components'
import UseAnimations from 'react-useanimations'
import loading from 'react-useanimations/lib/loading'
import { XCircle, CheckCircle, AlertTriangle } from 'react-feather'
import { BadgeProps, BadgeVariant } from './types'
import { Flex } from '../Flex'
import { Text, TextVariant } from '../Text'

const getColorByBadgeVariant = (variant: BadgeVariant, theme: DefaultTheme) => {
  switch (variant) {
    case BadgeVariant.ERROR:
      return theme.colors.red
    case BadgeVariant.SUCCESS:
      return theme.colors.green
    case BadgeVariant.WARNING:
      return theme.colors.yellow
    default:
      return theme.colors.gray6
  }
}

const getIconByBadgeVariant = (variant: BadgeVariant, theme: DefaultTheme) => {
  switch (variant) {
    case BadgeVariant.ERROR:
      return <XCircle color={theme.colors.red} />
    case BadgeVariant.SUCCESS:
      return <CheckCircle color={theme.colors.green} />
    case BadgeVariant.WARNING:
      return <AlertTriangle color={theme.colors.yellow} />
    default:
      return <UseAnimations animation={loading} strokeColor={theme.colors.white3} />
  }
}

const BadgeWrapper = styled(Flex)<{ variant: BadgeVariant; customPadding?: string }>`
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  padding: ${({ customPadding }) => customPadding || '8px 16px'};
  gap: 10px;
  background: ${({ theme }) => theme.colors.gray10};
  border-radius: 58px;
  width: fit-content;
  ${({ theme }) => theme.mediaQueries.mobile} {
    height: auto;
  }
`

const StatusBadge: React.FC<BadgeProps> = ({ title, customPadding, ...props }) => {
  const { variant } = props
  const theme = useTheme()
  return (
    <BadgeWrapper {...props} {...{ customPadding }}>
      <Flex width={24} height={24}>
        {getIconByBadgeVariant(variant, theme)}
      </Flex>

      <Text variant={TextVariant.BODY_DEFAULT} color={getColorByBadgeVariant(variant, theme)} textAlign="center">
        {title}
      </Text>
    </BadgeWrapper>
  )
}

export default StatusBadge
